<template>
  <div>
    <template v-if='child.IsLeaf === "1"'>
      <router-link :to='{ path: "/" + child.MenuCode, query: { parameterStr: child.Parameter } }'
        style='text-decoration: none;'>
        <el-menu-item :index='child.MenuCode'>
          <i :class='child.Icon' class='menuIcon'></i>
          <span class='menuSpan'>{{child.MenuName}}</span>
        </el-menu-item>
      </router-link>
    </template>

    <el-submenu v-else :index='child.MenuCode' popper-append-to-body>
      <template slot='title'>
        <i :class='child.Icon' class='menuIcon'></i>
        <span class='menuSpan'>{{child.MenuName}}</span>
      </template>
      <sidebar-item
        v-for='child2 in child.Children'
        :key='child2.MenuCode'
        :child='child2'
      />
    </el-submenu>
  </div>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    child: {
      type: Object,
      required: true
    }
  },

  methods: {
  }
}
</script>

<style scoped>
.menuIcon {
  -webkit-box-flex: 0;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 6px;
  font-size: 1rem;
  width: 1.75rem;
}
.menuSpan {
  padding-left: 10px;
}
</style>
